import { useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";
import { backendService } from "../services/backend.service";
import type { CreateRecurringShiftRequest } from "../utils/models";

export const useCalculateRecurringShiftDailyHours = (
	request: CreateRecurringShiftRequest | null,
	startDate: DateTime | undefined,
	endDate: DateTime | undefined,
) => {
	return useQuery<DateTime[]>({
		queryKey: ["calculateRecurringShiftDailyHours", request, startDate?.toFormat("yyyy-MM-dd"), endDate?.toFormat("yyyy-MM-dd")],
		queryFn: async () => {
			if (!request || !startDate) return [];

			const response = await backendService.calculateRecurringShiftDailyHours(request, startDate.toFormat("yyyy-MM-dd"), endDate?.toFormat("yyyy-MM-dd"));
			return response.data;
		},
		enabled: !!request && !!startDate,
	});
};
